"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTagsPaginated = exports.getTags = void 0;
const registry_call_1 = require("./registry-call");
const contentTypes = require("./content-types");
/**
 * Fetches a list of tags.
 *
 * OCI Distribution Specification endpoint: `/v2/<name>/tags/list`
 *
 * @returns Returns a list of tags.
 */
async function getTags(registryBase, repo, username, password, pageSize = 1000, maxPages = Number.MAX_SAFE_INTEGER, options = {}, callChainObserver = { visitedUrls: [] }) {
    const endpoint = `/${repo}/tags/list`;
    return await (0, registry_call_1.paginatedV2Call)(registryBase, contentTypes.JSON, username, password, endpoint, "tags", pageSize, maxPages, options, callChainObserver);
}
exports.getTags = getTags;
/**
 * Fetches a list of tags using Docker Registry v2 API pagination.
 * This function uses the "last" marker approach which allows for unbounded
 * retrieval of tags without the limitations of our previous implementation.
 *
 * @param registryBase - The base URL of the registry
 * @param repo - The repository name
 * @param username - Optional username for authentication
 * @param password - Optional password for authentication
 * @param pageSize - Number of tags to fetch per request (default: 1000)
 * @param options - Additional request options
 * @param callChainObserver - For tracking request chains
 * @returns Returns a complete list of all tags in the repository
 */
async function getTagsPaginated(registryBase, repo, username, password, pageSize = 1000, options = {}, callChainObserver = { visitedUrls: [] }) {
    const endpoint = `/${repo}/tags/list`;
    return await (0, registry_call_1.paginatedV2CallWithLastMarker)(registryBase, contentTypes.JSON, username, password, endpoint, "tags", pageSize, options, callChainObserver);
}
exports.getTagsPaginated = getTagsPaginated;
//# sourceMappingURL=get-tags.js.map